import { Uitsluiting } from "../infra/personalia-schema";
import { createISWSideEffect, initISWSideEffect } from "../../shared/components/isw-side-effects/create-isw-helpers";

export const uitsluitingenSideEffects = createISWSideEffect<{ list: Uitsluiting[] }>((bag): void => {
  const { draft, prev } = bag;
  const { list: currentList } = draft;
  const { list: previousList } = prev;

  const foundUitsluitingenIndex = currentList.findIndex(
    (current, index): boolean =>
      previousList[index] &&
      current.maatschappijCode !== previousList[index].maatschappijCode &&
      !!previousList[index].maatschappijCode
  );

  if (foundUitsluitingenIndex !== -1) {
    currentList[foundUitsluitingenIndex] = {
      uitsluitingId: null,
      maatschappijCode: currentList[foundUitsluitingenIndex].maatschappijCode,
      maatschappijOmschrijving: "",
      uitsluitingsdatum: null,
      reden: ""
    };
  }
});

export const determineUitsluitingenSideEffects = initISWSideEffect<{ list: Uitsluiting[] }>(uitsluitingenSideEffects)();
